import { useState } from 'react';
import type { TimetablePrint } from '../../services/timetableService';
import { usePdfExport, useSchoolBranding } from '../../utils/pdf';
import TimetableDocument from './pdf/TimetableDocument';

/** A name as it can sit in a file name — "Class 6 A" → "Class_6_A". */
const fileSlug = (s: string) => s.replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');

/**
 * Timetable PDFs drawn in the browser from the pages the server lays out — the
 * board's Print menu and My Timetable. `busy` holds the button while it draws;
 * a failure is shown by the PDF export itself.
 */
export function useTimetablePdf() {
  const { generate } = usePdfExport();
  const { branding } = useSchoolBranding();
  const [busy, setBusy] = useState(false);

  const download = async (load: () => Promise<TimetablePrint>, packName: string) => {
    setBusy(true);
    let name = packName;
    try {
      await generate(async () => {
        const print = await load();
        if (print.pages.length === 1) name = `Timetable_${fileSlug(print.pages[0].title)}`;
        return <TimetableDocument print={print} branding={branding} generatedAt={new Date().toISOString()} />;
      }, () => `${name}.pdf`);
    } finally {
      setBusy(false);
    }
  };

  return { download, busy };
}
